import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2, KeyRound, Mail, UserCog } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { staffLogin, setStaffToken, apiErrMsg } from '../../lib/api';

export default function StaffLoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setLoading(true);
    try {
      const r = await staffLogin(email.trim().toLowerCase(), password);
      setStaffToken(r.token);
      toast.success(`Welcome ${r.staff?.name || ''}`);
      nav('/staff/dashboard');
    } catch (e2) {
      toast.error(apiErrMsg(e2, 'Login failed'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <main
      className="min-h-screen bg-[hsl(0_0%_4%)] text-white flex items-center justify-center px-4 py-10"
      data-testid="staff-login-page"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 rounded-full border border-[hsl(43_92%_56%)]/45 bg-[rgba(245,185,66,0.06)] px-3.5 py-1.5">
            <UserCog className="h-3.5 w-3.5 text-[hsl(43_92%_56%)]" />
            <span className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_72%)] font-semibold">
              AlveeFx · Staff Portal
            </span>
          </div>
          <h1 className="mt-4 font-display text-3xl">Staff Login</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Daily kajer log submit koro, AI score dekho, monthly salary track koro.
          </p>
        </div>

        <Card className="bg-white/[0.02] border-white/10 backdrop-blur">
          <CardContent className="p-6">
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
                  Email
                </Label>
                <div className="relative mt-1">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@alveefx.com"
                    className="pl-9 h-11 bg-white/[0.03] border-white/10"
                    required
                    data-testid="staff-login-email"
                  />
                </div>
              </div>
              <div>
                <Label className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
                  Password
                </Label>
                <div className="relative mt-1">
                  <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="pl-9 h-11 bg-white/[0.03] border-white/10"
                    required
                    data-testid="staff-login-password"
                  />
                </div>
              </div>
              <Button
                type="submit"
                disabled={loading}
                className="w-full h-11 bg-gradient-to-r from-[hsl(43_92%_56%)] to-[hsl(38_85%_50%)] hover:from-[hsl(43_92%_62%)] hover:to-[hsl(38_85%_56%)] text-black font-bold border-0"
                data-testid="staff-login-submit"
              >
                {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
                Log in
              </Button>
              <p className="text-center text-[11px] text-muted-foreground">
                Password bhule gele admin er shathe contact koro.
              </p>
            </form>
          </CardContent>
        </Card>
      </div>
    </main>
  );
}
